/**
 *
 * @Container props.data
 * className: css classes for parent container
 * data{
 * className,
 * url
 * }
 */

const Video = (props) => {
  const { className, url, title } = props.data;
  return (
    <section className={`Video ${className ? className : ""}`}>
      <div
        style={{
          position: "relative",
          width: "100vw",
          height: "80vh",

          overflow: "hidden",
        }}
      >
        <div
          style={{
            zIndex: 100,
            position: "absolute",
            padding: "1rem",
            color: "white",
          }}
        >
          {title}
        </div>
        <iframe
          src={url}
          width="640"
          height="360"
          frameborder="0"
          scrolling="no"
          allowfullscreen
          autoPlay
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          style={{
            position: "absolute",
            border: "none",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        ></iframe>
      </div>
    </section>
  );
};

export default Video;
